import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type TtbPaymentModuleSpecsFragment } from '../../../../api/fragments/TtbPaymentModuleSpecs';
import TtbPaymentSettingActions from './TtbPaymentSettingActions';

export type TtbPaymentSettingsTableProps = {
    module: TtbPaymentModuleSpecsFragment;
};

export type TtbPaymentSettingSpecs = TtbPaymentModuleSpecsFragment['paymentSettings'][number];

const TtbPaymentSettingsTable = ({ module }: TtbPaymentSettingsTableProps) => {
    const { t } = useTranslation(['ttbPaymentModuleDetails']);

    const renderActions = useCallback(
        (record: TtbPaymentSettingSpecs) => <TtbPaymentSettingActions module={module} paymentSetting={record} />,
        [module]
    );

    return (
        <Table dataSource={module.paymentSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('ttbPaymentModuleDetails:paymentSettingsTable.columns.displayName')}
            />
            <Table.Column
                key="currency"
                dataIndex="currency"
                title={t('ttbPaymentModuleDetails:paymentSettingsTable.columns.currency')}
            />
            <Table.Column
                key="amount"
                dataIndex="amount"
                title={t('ttbPaymentModuleDetails:paymentSettingsTable.columns.amount')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('ttbPaymentModuleDetails:paymentSettingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default TtbPaymentSettingsTable;
